<style lang="less">
    .page_con.detail{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
            background:url("../assets/images/topbar-gerenchengji.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.5rem;
                height:auto;
                display: block;
            }
        }
        .content_con{
            width:92%;
            height:89vh;
            margin:1vh auto;
            padding:3vh 2vw;
            background:#fff;
            border:.01rem solid #ddd;
            overflow-x: hidden;
            overflow-Y: auto;
            .thead{
                width:100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                padding:0 2vw;
                .date{
                    width:28%;
                    background: #eee;
                }
                .type{
                    width:21%;
                }
                .score{
                    width:11%;
                }
                .count{
                    width:11%;
                }
                .kit{
                    width:11%;
                }
                .medal{
                    width:11%;
                }
                >div{
                    border:.01rem solid #693905;
                    border-radius: .1rem;
                    color:#693905;
                    padding:.5vw;
                }
            }
            .list{
                width:100%;
                border:.01rem solid #ddd;
                margin-top: 2vw;
                padding:.1rem;
                background:#E7E3BD;
                border-radius: 15px;
                li{
                    width:100%;
                    height:7vh;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    text-align: center;
                    background: url("../assets/images/bg-gerenchengji.png") no-repeat;
                    background-size: 100% 100%;
                    margin-bottom: .05rem;
                    padding:0 0 .1rem;
                    color:#693905;
                    .date{
                        width:30%;
                    }
                    .type{
                        width:22%;
                    }
                    .score{
                        width:12%;
                    }
                    .count{
                        width:12%;
                    }
                    .kit{
                        width:12%;
                    }
                    .medal{
                        width:12%;
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="page_con detail">
        <div class="top_con">
            <img src="../assets/images/closer.png" alt="" @click="$router.go(-1)">
        </div>
        <div class="content_con">
            <div class="thead">
                <div class="date"><span>日期</span></div>
                <div class="type"><span>學習項目</span></div>
                <div class="score"><span>積分</span></div>
                <div class="count"><span>總分</span></div>
                <div class="kit"><span>錦囊</span></div>
                <div class="medal"><span>獎牌</span></div>
            </div>
            <ul class="list">
                <li v-for="(item,index) in list" :key="index">
                    <div class="date">{{item.date | dateChange}}</div>
                    <div class="type">{{item.game_name}}</div>
                    <div class="score">{{item.score}}</div>
                    <div class="count">{{item.all_score}}</div>
                    <div class="kit">{{item.medal}}</div>
                    <div class="medal">{{item.medal}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            list:[],
        }
    },
    mounted() {
        this.getData();
    },
    filters:{
        dateChange(times){
            let time = new Date(times*1000);
            let y = time.getFullYear();
            let m = time.getMonth() + 1;
            let d = time.getDate();
            d = d>9?d:('0'+d);
            m = m>9?m:('0'+m);
            return d+'/'+m+'/'+y;
        }
    },
    methods: {
        getData(){
            let vm = this;
            this.$http.get('/IndexDaily/results?rest_key=1').then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.list = res.data.data.results;
                }
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/detail.vue